import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		transporteonEmail: Yup.string()
			.required(t("fill_required_fields"))
			.email(t("invalid_email_format")),
		transporteonCompany: Yup.string().required(t("fill_required_fields")),
	});
};
